import React, { useState } from 'react';
import MetaTags from 'react-meta-tags';
import classnames from 'classnames';
import moment from 'moment';
import { Col, Container, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { DateRangePicker } from 'rsuite';
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import StatusSummaryCards from './components/StatusSummaryCards.component';
import NotificationLogList from './components/NotificationLogList.component';
import RedisQueueList from './components/RedisQueueList.component';

const NotificationManager = () => {
  const [activeTab, setActiveTab] = useState('log');
  // No default range — this table is low-volume, filtering to "last N days"
  // by default can hide the only rows that exist. Users can narrow via the picker.
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Notification Manager | DH OMS</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col xl={6}>
              <DashBreadcrumb
                title="Manage Queue"
                breadcrumbItem="Notification Manager"
              />
            </Col>
            <Col xl={6} className="text-end">
              <DateRangePicker
                placeholder="Select Date Range (all time by default)"
                placement="bottomEnd"
                container={() => document.body}
                value={
                  startDate && endDate
                    ? [new Date(startDate), new Date(endDate)]
                    : null
                }
                onChange={(dates) => {
                  if (dates) {
                    setStartDate(moment(dates[0]).format('YYYY-MM-DD'));
                    setEndDate(moment(dates[1]).format('YYYY-MM-DD'));
                  }
                }}
                onClean={() => {
                  setStartDate('');
                  setEndDate('');
                }}
              />
            </Col>
          </Row>

          <StatusSummaryCards dateFrom={startDate} dateTo={endDate} />

          <Row className="mt-3">
            <Col>
              <Nav tabs className="nav-tabs-custom card-header-tabs flex-nowrap">
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 'log' })}
                    onClick={() => toggleTab('log')}
                    style={{ cursor: 'pointer' }}
                  >
                    <span className="d-sm-block">Notification Log</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 'queue' })}
                    onClick={() => toggleTab('queue')}
                    style={{ cursor: 'pointer' }}
                  >
                    <span className="d-sm-block">Redis Queue</span>
                  </NavLink>
                </NavItem>
              </Nav>

              {activeTab === 'log' ? (
                <NotificationLogList dateFrom={startDate} dateTo={endDate} />
              ) : (
                <RedisQueueList />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NotificationManager;
